

// CHATBOX Action
export const CHATBOX_ADD = 'CHATBOX_ADD'
export const CHATBOX_REMOVE = 'CHATBOX_REMOVE'